// extracted by mini-css-extract-plugin
module.exports = {"floatingClearSelectionButton":"FloatingClearSelectionButton_floatingClearSelectionButton__jdv6U"};